import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'

import settings from './settings'
import language from './language'
import requestStatus from './requestStatus'
import authUser from '../routes/auth/reducer'
import userInfo from '../routes/app/routes/profile/reducer'
import listGlasses from '../routes/app/routes/glasses-list/reducer'
import glassesDetail from '../routes/app/routes/glasses-detail/reducer'
import listGlassesGroup from '../routes/app/routes/glasses-group/reducer'
import glassesGroupDetail from '../routes/app/routes/glasses-group-detail/reducer'
import listStores from '../routes/app/routes/stores/reducer'
import dashboard from '../routes/app/routes/dashboard/reducer'
import billing from '../routes/app/routes/checkout/reducer'
import brand from '../routes/app/routes/brand/reducer'
import shopLocator from '../routes/app/routes/shop-locator/reducer'
import shopLocale from '../routes/app/routes/shop-locale/reducer'
import invoice from '../routes/app/routes/invoice/reducer'
import delegate from '../routes/app/routes/delegate-list/reducer'
import listLens from '../routes/app/routes/lens-list/reducer'

// Admin
import userAdmin from '../routes/admin/routes/users/reducer'
import admin from '../routes/admin/routes/dashboard/reducer'
import summary from '../routes/admin/routes/summary-list/reducer'

const reducers = {
  routing: routerReducer,
  settings,
  language,
  requestStatus,
  authUser,
  userInfo,
  ...listGlasses,
  glassesDetail,
  ...listGlassesGroup,
  glassesGroupDetail,
  ...listStores,
  ...userAdmin,
  dashboard,
  billing,
  brand,
  shopLocator,
  shopLocale,
  invoice,
  delegate,
  admin,
  ...summary,
  ...listLens
}

module.exports = combineReducers(reducers)



// WEBPACK FOOTER //
// ./reducers/index.js